import { Supabase } from '../Utils/supabase.config';

export const googleAuthService = {
  isSignedIn: async () => {
    const { data } = await Supabase.auth.getUser();
    return !!data.user;
  },

  getCurrentUser: async () => {
    const { data } = await Supabase.auth.getUser();
    return data.user ?? null;
  },

  signIn: async () => {
    try {
      // Use OAuth flow for web - this will redirect to Google and back
      // Get the full current URL including port
      const redirectUrl = window.location.origin + window.location.pathname;
      
      const { data, error } = await Supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: redirectUrl,
          skipBrowserRedirect: false,
        },
      });

      if (error) {
        throw error;
      }

      return { success: true, data };
    } catch (error: any) {
      // Return error without logging - let the UI handle it
      return { success: false, error: error?.message || 'Google OAuth failed' };
    }
  },

  signOut: async () => {
    try {
      const { error } = await Supabase.auth.signOut();
      if (error) throw error;
      return { success: true };
    } catch (error: any) {
      return { success: false, error: error?.message || 'Google Sign-Out failed' };
    }
  },
};

export default googleAuthService;


